import { render, staticRenderFns } from "./ContactsView.vue?vue&type=template&id=69cb4b5c&scoped=true&"
import script from "./ContactsView.vue?vue&type=script&lang=js&"
export * from "./ContactsView.vue?vue&type=script&lang=js&"
import style0 from "./ContactsView.vue?vue&type=style&index=0&id=69cb4b5c&lang=scss&scoped=true&"
import style1 from "./ContactsView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cb4b5c",
  null
  
)

export default component.exports